import { IconName } from '../../components/icon';
import { getColorStyle, TrilogyColor } from './Color';
/**
 * Alert State
 */
export var StatusState;
(function (StatusState) {
    StatusState["SUCCESS"] = "SUCCESS";
    StatusState["INFO"] = "INFO";
    StatusState["WARNING"] = "WARNING";
    StatusState["ERROR"] = "ERROR";
})(StatusState || (StatusState = {}));
/**
 * Returns alert's classname depending on alert type
 * @param statusType {string} - Alert type
 * @returns {string} - Alert value
 */
export var getStatusClassName = function (statusType) {
    switch (statusType) {
        case 'SUCCESS':
            return 'success';
        case 'INFO':
            return 'info';
        case 'WARNING':
            return 'warning';
        case 'ERROR':
            return 'error';
        default:
            return '';
    }
};
/**
 * Returns status style depending on alert type
 * @param statusType {string} - Alert type
 * @returns { color: string, backgroundColor: string} - color and background color value
 */
var STATUS_COLORS = {
    SUCCESS: { color: TrilogyColor.SUCCESS, backgroundColor: TrilogyColor.SUCCESS_FADE },
    INFO: { color: TrilogyColor.INFO, backgroundColor: TrilogyColor.INFO_FADE },
    WARNING: { color: TrilogyColor.WARNING, backgroundColor: TrilogyColor.WARNING_FADE },
    ERROR: { color: TrilogyColor.ERROR, backgroundColor: TrilogyColor.ERROR_FADE },
    DEFAULT: { color: TrilogyColor.MAIN, backgroundColor: TrilogyColor.MAIN_FADE },
};
export var getStatusStyle = function (statusType) {
    var colors = STATUS_COLORS[statusType || 'DEFAULT'];
    return {
        color: getColorStyle(colors.color),
        backgroundColor: getColorStyle(colors.backgroundColor),
    };
};
/**
 * Returns status icon name depending on alert type
 * @param statusType {string} - Alert type
 * @returns {string} - Alert value
 */
export var getStatusIconName = function (statusType) {
    switch (statusType) {
        case 'SUCCESS':
            return IconName.CHECK_CIRCLE;
        case 'INFO':
            return IconName.INFOS_CIRCLE;
        case 'WARNING':
            return IconName.ALERT;
        case 'ERROR':
            return IconName.EXCLAMATION_CIRCLE;
        default:
            return IconName.INFOS_CIRCLE;
    }
};
//# sourceMappingURL=data:application/json;base64,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